import { createContext, useReducer, useEffect } from "react";
import { THEME_COLORS } from "../constants/CommonConstants";
import { useSelector } from "react-redux";

export const ThemeContext = createContext();

const ThemesReducer = (state, action) => {
  switch (action.type) {
    case "LIGHT":
      return { ...state, themeChange: THEME_COLORS.LIGHT };
    case "DARK":
      return { ...state, themeChange: THEME_COLORS.DARK };
    case "DEFAULT":
      return { ...state, themeChange: THEME_COLORS.DEFAULT };
    default:
      return state;
  }
};

export const ThemeContextProvider = ({ children }) => {
  const { defaultWorkspaceTheme } = useSelector(
    (state) => state?.GetWorkspaceListReducer?.user || {}
  );

  const [state, dispatch] = useReducer(ThemesReducer, {
    themeChange: defaultWorkspaceTheme
      ? defaultWorkspaceTheme
      : THEME_COLORS.DEFAULT,
  });

  useEffect(() => {
    if (defaultWorkspaceTheme) {
      dispatch({
        type: defaultWorkspaceTheme.toUpperCase() || "DEFAULT", // Handles "default", "light", "dark"
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ThemeContext.Provider value={{ ...state, dispatch }}>
        {children}
      </ThemeContext.Provider>
    </>
  );
};
